import * as React from 'react';
import { Link } from 'react-router-dom';
import styles from './messages.scss';
import { MessagesToUser } from 'app/shell/components/messages-to-user';
import { MessagesToUserProps } from 'app/shell/components/messages-to-user/types';
import { messagesToUserTranslation } from 'app/shell/constants';
import { containerFactory, DefaultContainerProps } from 'app/infrastructure/redux';
import { STATE } from 'app/constants';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { routeConstants } from 'app/routes/route-constants';
import { scrollToTop } from 'app/infrastructure/platform/routing';

export class MessagesComponent extends React.Component<MessagesToUserProps & DefaultContainerProps> {
  public static statePath: string = STATE.app;

  public componentDidMount() {
    scrollToTop();
  }

  public render() {
    const { sharedState } = this.props;
    const messageAdminReadRigths = !!(sharedState && sharedState.access && sharedState.access.adminPanel &&
      sharedState.access.adminPanel.message && sharedState.access.adminPanel.message.read);

    return <MainGridContainer className={styles.messagesView}>
      <div className={`row ${styles.header}`}>
        <h1 className="col-lg-9 col-md-12">{this.props.translation.messages}</h1>
        {messageAdminReadRigths && <div className="col-lg-3 col-md-12">
          <div className={styles.manageButton}>
            <Link
              id={'messages-list-link-manage-button'}
              to={routeConstants.administrationMessagesList}
              className="btn btn-primary">
              {this.props.translation.manage_messages_button}
            </Link>
          </div>
        </div>}
      </div>
      <div className={styles.messageSection}>
        <h2>{this.props.translation.unread_messages}</h2>
        <MessagesToUser showNoItemsMessage={true} showUnreadMessagesOnly={true} />
      </div>
      <div className={styles.messageSection}>
        <h2>{this.props.translation.read_messages}</h2>
        <MessagesToUser showNoItemsMessage={true} />
      </div>
    </MainGridContainer>;
  }
}

const container = containerFactory<MessagesToUserProps>(
  MessagesComponent,
  {},
  {},
  messagesToUserTranslation
);

export { container as Messages };
